import { Client, Company, isClient, isCompany } from 'src/constants';
import { useAppSelector } from 'src/hooks/useStore';
import {
  selectAllCompaniesMap,
  selectClientsMap,
} from 'src/store/clients/types';

type EntityType = Client | Company;

export const useEntity = (
  entityType: 'client' | 'company' | undefined,
  entityId: string | undefined,
): EntityType | undefined => {
  const companies = useAppSelector(selectAllCompaniesMap);
  const clients = useAppSelector(selectClientsMap);

  if (!entityType || !entityId) return undefined;

  if (entityType === 'client') {
    return clients.get(entityId);
  }
  return companies.get(entityId);
};

export const getEntityName = (entity: EntityType | undefined) => {
  if (isClient(entity))
    return `${entity.fields.givenName ?? ''} ${entity.fields.familyName ?? ''}`.trim();
  if (isCompany(entity)) return entity.fields.name;
  return '';
};
